import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from "../../../../axios";
import SvgImport from "../../../../Icons/SectionIcons/importSection";
import ZoneCard from './ZoneCard';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import CustomizedAlert from '../../../../ReusableComponents/Alert/CustomizedAlert';
import { useTranslation } from 'react-i18next';
import $ from 'jquery'; 
import { useMediaQuery } from '@material-ui/core';
import { getFormId } from '../../IFormDesignerLogic';
import Badge from "@material-ui/core/Badge";
import helpDirection from "../../../../Resources/helpDirection.json"
import debounce from 'lodash-es/debounce';
import { GetStateFromData } from '../../../CustomHooks/CustomHooks';
import styles1 from "./Zoning.module.css";
import { handleWinObjects } from '../../ReUsableLogics';


const isTablet = window.matchMedia("(max-width: 1024px)").matches;
const useStyles = makeStyles((theme)=>({
  root:{
    margin: "-6px !important",
    display:"flex",
    paddingTop:"4px",
    "& .MuiPagination-ul": {
      "& > li": {
        "& button": {
          margin: "1px !important"
        },
      },
    },
  },

  selected: {
    backgroundColor: '#0072C6',
    color:'#000000',
    height: "25px !important",
  },
  button: {
    position: 'relative',
  },
  dialogContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    touchAction: "none",
    overflow: 'hidden'
  },
  dialog: {
    position:"absolute",
    height:"492px",
    maxHeight: "100%",
    width:"1047px" ,
    maxWidth:"100%",
    minWidth:"400px",
    overflow: "hidden",
    zIndex: "1000",
    direction: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ?  "rtl" : "ltr",
  },
  dialogIpad: {
    position:"absolute",
    height: isTablet ? "unset" : "492px",
    maxHeight: "100%",
    width:"740px" ,
    maxWidth: isTablet ? "97%" : "100%",
    minWidth:"400px",
    overflow: "hidden",
    zIndex: "1000",
    direction: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ?  "rtl" : "ltr"
  },
  dialogTitle: {
    padding: "10px 24px 11px 24px",
    width: "100%",
    height: "40px",
    paddingTop:"4px"
  
  },
  dialogHead: {
    textAlign: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "right" : "left",
    color: "#000000",
    font:"normal normal 600 14px/19px Open Sans", 
    fontWeight:"600",
  },
  dialogContent: {
    padding: 0,
    width:"100%",
  },
  dialogActions: {
    height: 50,
    width:"100%",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
    opacity: 1,
    padding:  "11px 0px 11px",
  },
  divider: {
    backgroundColor:"#E4E4E4",
  },
  dragArea1: {
    width: "1009px",
    maxWidth: "100%",
    minWidth: "300px",
    height: "369px",
    margin: "17px 19px 15px",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
    border: "1px dashed #484848",
    opacity: 0.5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    '&:active': {
        border: "2px solid #fff",
    }
  },
  dragArea2: {
    width: "1009px",
    maxWidth: "100%",
    minWidth: "300px",
    height: "331px",
    margin: "17px 19px 15px",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
    border: "1px dashed #484848",
    opacity: 0.5,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    '&:active': {
        border: "2px solid #fff",
    }
  },
  image: {
    objectFit: "cover",
    borderRadius: "5px",
  },
  header1: {
    textAlign: "left",
    font: "normal normal normal 14px/19px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
  },
  header2: {
    marginTop: "13px",  
    textAlign: "left",
    font: "normal normal normal 10px/14px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
  },
  page: {
    selected:{
      backgroundColor: "#0072C6",
    }

  },
  uploadBtn: {
    width: "85px",
    height: "28px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #338ED1",
    borderRadius: "2px",
    opacity: 1,
  },
  uploadBtnlabel: {
    textTransform: "none",
    color: "#0072C6",
    letterSpacing: "0px",
    textAlign: "left",
    font: "normal normal 600 12px/17px Open Sans",
    opacity: 1,
  },
  btn1: {
    width: "54px",
    height: "28px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 8px 6px 8px",
    marginRight: "6px",
    marginLeft: "6px",
  },
  btn2: {
    width: "79px",
    height: "28px",
    background: "#0072C6 0% 0% no-repeat padding-box",
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 6px 6px 6px",
    marginLeft: "6px",
    '&:hover': {
      background: "#0072C6",
    }
  },
  btn1label: {
    textTransform: "none",
    color: "#606060",
    font: "normal normal 600 12px/17px Open Sans",
    opacity: 1
  },
  btn2label: {
    textTransform: "none",
    color: "#FFFFFF",
    letterSpacing: "0px",
    textAlign: "left",
    font: "normal normal 600 12px/17px Open Sans",
    opacity: 1,
  },
  paper: {
    padding: "5px",
    margin: "5px",
    textAlign: 'center',
  },
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: isTablet ? "column-reverse" : "unset"
  },
  grid1: {
    width: isTablet ? "97%" : "287px",
    height: isTablet ? "300px" : "368px",
    minHeight: isTablet ? "300px" : "368px",
    margin: isTablet ? "16px 8px 16px 8px" : "17px 19px 16px 20px",
    display:"flex",
    overflowY: "auto",
    overflowX: "auto",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "0.5px solid #C4C4C4",
    opacity: 1,
   
  },
  grid11: {
    display:"flex",
    flexDirection: "column",
    width: "100%"
  },
  grid2: {
    maxWidth: isTablet ? "unset" : "702px",
    height: isTablet ? "400px" : "369px",
    margin: isTablet ? "26px 0px 26px 0px" : window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "17px 0px 15px 19px" :"17px 19px 15px 0px",
    justifyContent:"flex-start",
    border: "1px solid #C7C7C7",
    opacity: 1,
    
  },
  grid21: {
    width: "100%",
    height: isTablet ? "370px" : "330px",
    overflow: "auto",
  },
  grid22: {
    borderTop: "1px solid #C7C7C7",
    width: "100%",
    height: "28px",
    textAlign: "center",
    letterSpacing: "0px",
    color: "#0072C6",
    opacity: 1,
    padding: "5px", 
  },
  grid23: {
    borderTop: "1px solid #C7C7C7",
    width: "100%",
    height: "28px",
    textAlign: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "right" : "left",
    letterSpacing: "0px",
    color: "#0072C6",
    opacity: 1,
    paddingInline:'8px',
    // paddingLeft: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "0px" : "20px",
    // paddingRight: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "20px" : "0px",
    flex: 1, 
    display: 'flex'
  },
  div1: {
    paddingTop: "8px"
  },
  div2: {
    flex: 1, 
    display: 'flex', 
    justifyContent: 'flex-end',
  },
  div3: {
    paddingTop: "8px",
    font: "normal normal normal 11px/15px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
    marginRight: "15px"
  },
  div4: {
    height: "340px",
    position: "relative",
  },
  canvas: {
    width: "100%",
    height: "341px",
    border: "1px solid red",
  },
  zoneHead: {
    height: "28px",
    width: "100%",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
    border: "0.5px solid #C4C4C4",
    textAlign: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "right" : "left",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
    font: "normal normal 700 13px Open Sans",
    padding: "6px 15px 5px 15px",
  },
  img: {
    maxWidth: "693px",
  },
  btn: {
    width: "43px !important",  
    height: "22px",
    background: "#0072C6 0% 0% no-repeat padding-box",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 8px 6px 8px"
  },
  btnlabel: {
    textTransform: "none",
    font: "normal normal 600 8px/11px Open Sans",
    color: "#ffffff",
  },
  cardBodyProp: {
    padding: "11px 13px 12px 8px",
    borderBottom: "0.5px solid #C4C4C4",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
  },
  rectangle: {
    border: "1px solid #FF0000",
    position: "absolute",
  }

}));

export default function Zoning(props) {
  const matches = useMediaQuery('(min-width: 1181px)');
  const contexts = GetStateFromData(props.containerId);

  const {formState2,microFrontendData }=contexts.contexts;


  const classes = useStyles();
  const {open, onClose} = props;
  const [img, setImg] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [imgWt, setImgWt] = useState();
  const [imgHt, setImgHt] = useState();
  const [zoneList, setZoneList] = useState([]);
  const [multi, setMulti] = useState(false);
  const [card, setCard] = useState();
  const [pages, setPages] = useState(-1);
  const [pageNo, setPageNo] = useState(1);

  const { t } = useTranslation();
  const translationStyles=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
  const input = document.getElementsByClassName("zoneFile");
  const [alertData, setAlertData] = useState({'open':false, 'showConfirm':'showNotification'});

  useEffect(() => {
    if(formState2["Zonelist"] === undefined){
      formState2["Zonelist"] = [];
    }
    if(formState2["Zonelist"] !== undefined){
      setZoneList(formState2["Zonelist"]);
    }
  }, []);
 
  const handleSave = (e) => { 
    formState2["Zonelist"] = [...zoneList];
    onClose();
    e.preventDefault();
  };

  const handleCancel = (e) => { 
    onClose();
    e.preventDefault();
  };

  async function handleDrop(e) {
    e.preventDefault();
    const {
      dataTransfer: { files }
    } = e;
    let imageObj =  files[0];
    const imageBase64 =  await convertBase64(imageObj);
    if(imageObj.type === "image/tiff"){
      var remainingURL = "/idesign/zoning/loadImage";
      const formData = new FormData();

      formData.append('formId',getFormId());
      formData.append('file', imageObj);
      formData.append('pageNumber', 1);
      formData.append("processName",microFrontendData?.processName)
      axios.post(remainingURL, formData , {withCredentials:true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }})
      .then((response) =>{
        const dataResponse=response?.data ? response : {};
        const newDataResponse = dataResponse ? dataResponse.data ?  dataResponse.data : {} : {};
        var image =  `data:image/png;base64,${newDataResponse?.imageBuffer}`;
        setImg(true);
        setMulti(true);
        setPages(newDataResponse?.totalPages);
        setFileName(imageObj.name);
        setFileData(image);
        setImageFile(image);
      }).catch(function (error) {
         console.log(error);
      });
    } else if(imageObj.type === "image/jpeg" || imageObj.type === "image/png") {
      setFileName(imageObj.name);
      setImg(true);
      setImageFile(imageBase64);  
    } else {
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t('Invalid_File_Format')}`
     })
    }
  };

  const onDragOver = e => {
    e.preventDefault();
  };

  function upload(e) {
    input[0].click();
  }

  async function handleFileInput(event){
    let imageObj =  event.target.files[0];
    const imageBase64 = await convertBase64(imageObj);
    if(imageObj.type === "image/tiff"){

      var remainingURL = "/idesign/zoning/loadImage";
      const formData = new FormData();
        formData.append('formId',getFormId());
        formData.append('file', imageObj);
        formData.append('pageNumber', 1);
        formData.append("processName",microFrontendData?.processName)
      axios.post(remainingURL, formData , {withCredentials:true, 
         headers: {
        'Content-Type': 'multipart/form-data'
      }})
      .then((response) =>{
        const dataResponse=response?.data ? response : {};
        const newDataResponse = dataResponse ? dataResponse.data ?  dataResponse.data : {} : {};
        var image =  `data:image/png;base64,${newDataResponse?.imageBuffer}`;
        setImg(true);
        setMulti(true);
        setPages(newDataResponse?.totalPages);
        setFileName(imageObj.name);
        setFileData(image);
        setImageFile(image);
      }).catch(function (error) {
         console.log(error);
      });
    } else if(imageObj.type === "image/jpeg" || imageObj.type === "image/png") {
      setFileName(imageObj.name);
      setImg(true);
      setImageFile(imageBase64);  
    } else {
      setAlertData({
        open: true,
        showConfirm: "showNotification",
        alertType: "error",
        alertContentKey: `${t('Invalid_File_Format')}`,
        autoHideDuration: 4000 
     })
    }
  }

  const convertBase64 =(file) => {
    return new Promise((resolve,reject) => {
      const fileReader=new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror =(error) => {
        reject(error);
      };
    });
  };

  
  let image = new Image();
  image.src = imageFile;

  image.onload = function () {
   setImgWt(image.width);
   setImgHt(image.height);
  };

  

  const handleChange1 = (event, value) => {
    setPageNo(value);
    var remainingURL = "/idesign/zoning/loadImagePage";
    const formData = new FormData();
      formData .append('formId', getFormId());
      formData .append('file', fileData);
      formData .append('pageNumber', value);
      formData.append("processName",microFrontendData?.processName)
    axios.post(remainingURL, formData , {withCredentials:true, 
      headers: {
      'Content-Type': 'multipart/form-data'
    }})
    .then((response) =>{
      const dataResponse=response?.data ? response : {};
      const newDataResponse = dataResponse ? dataResponse.data ?  dataResponse.data : {} : {};
      var image =  `data:image/png;base64,${newDataResponse?.imageBuffer}`;
      setImg(true);
      setMulti(true);
      setCard(-1);
      setPages(newDataResponse?.totalPages);
      setImageFile(image);
    }).catch(function (error) {
       console.log(error);
    });
  };

  const handleChange2 = (value) => {
    setPageNo(value);
    var remainingURL = "/idesign/zoning/loadImagePage";
    const formData = new FormData();
      formData.append('formId', getFormId());
      formData.append('file', fileData);
      formData.append('pageNumber', value);
      formData.append("processName",microFrontendData?.processName)
    axios.post(remainingURL, formData , {withCredentials:true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }})
    .then((response) =>{
      const dataResponse=response?.data ? response : {};
      const newDataResponse = dataResponse ? dataResponse.data ?  dataResponse.data : {} : {};
      var image = `data:image/png;base64,${newDataResponse?.imageBuffer}`;
      setImg(true);
      setMulti(true);
      setPageNo(value);
      setPages(newDataResponse?.totalPages);
      setImageFile(image);
    }).catch(function (error) {
       console.log(error);
    });
  };

  function handleState(index) {
    setCard(index);
  }


const zoning = document.getElementById('zoning'); 
const zoningContainer = document.getElementById("zoningContainer")

const isSelectingZone = useRef(false);
const longPressTimer = useRef(null);
const LONG_PRESS_DELAY = 3000;

  const zoneStyle = {
    background: `url(${imageFile}) no-repeat`,
    height: imgHt,
    width: imgWt,
    cursor: "crosshair",
  }

  let element = null;    
  const mousedown = useRef(false);
  let mouse = {
    x: 0,
    y: 0,
    startX: 0,
    startY: 0
  };

  const currentObjDragged = useRef();

  const scroll = useCallback(debounce((unit) => {
    document.getElementById("zoningContainer").scrollTop += unit;
  }, 200, {leading: true, trailing: false, maxWait: 200}), []);

  const scrollX = useCallback(debounce((unit) => {
    document.getElementById("zoningContainer").scrollLeft += unit;
  }, 200, {leading: true, trailing: false, maxWait: 200}), []);

  const scrollZoning = (e) => {
    if(currentObjDragged.current && currentObjDragged?.current?.id === "zoning" && mousedown.current) {
      if(e.type === "touchmove"){
        const touch = window.event.touches[0];
        document.getElementById("zoningMainContainer").ontouchmove = function() {
          if(mousedown.current){
          let ypos = touch.clientY;
          let xpos = touch.clientX;
          let y = ypos - document.getElementById("zoningContainer")?.getBoundingClientRect().top;
          let x = xpos - document.getElementById("zoningContainer")?.getBoundingClientRect().left;           
          let z = y
            if(z >= document.getElementById("zoningContainer")?.clientHeight - 40) {
                scroll(5);
            }
            if(x >= document.getElementById("zoningContainer")?.clientLeft + 520) {
              scrollX(5);
            }
          
            setTimeout(() => {
              if(y <= 15)
                scroll(-5);
              if(x <= 15)
                scrollX(-25)
            },[100])
      } 
        }
      }else{
        document.getElementById("zoningMainContainer").onmousemove = function() {
          if(mousedown.current){
          let ypos = window.event.clientY;
          let xpos = window.event.clientX;
          let y = ypos - document.getElementById("zoningContainer")?.getBoundingClientRect().top;
          let x = xpos - document.getElementById("zoningContainer")?.getBoundingClientRect().left;           
          let z = window.event.offsetY;
            if(z >= document.getElementById("zoningContainer")?.clientHeight - 50) {
                scroll(5);
            }
            if(x >= document.getElementById("zoningContainer")?.clientLeft + 685) {
              scrollX(5);
            }
          
            setTimeout(() => {
              if(y <= 15)
                scroll(-5);
              if(x <= 15)
                scrollX(-25)
            },[100])
      } 
        }
      }
    }
  }

  function setMousePosition(e) {
    let ev = e || window.event; //Moz || IE
    if(ev.type === "touchstart" || ev.type === "touchmove"){
      const touch = ev.touches[0];
      if (touch.pageX) { //Moz
        mouse.x = touch.pageX - $(zoning).offset().left; //+ window.pageXOffset;
        mouse.y = touch.pageY - $(zoning).offset().top; //+ window.pageYOffset;
      } else if (touch.clientX) { //IE
        mouse.x = touch.clientX - $(zoning).offset().left;
        mouse.y = touch.clientY - $(zoning).offset().top; 
      }
    }else{
      if (ev.pageX) { //Moz
        mouse.x = ev.pageX - $(zoning).offset().left; //+ window.pageXOffset;
        mouse.y = ev.pageY - $(zoning).offset().top; //+ window.pageYOffset;
      } else if (ev.clientX) { //IE
        mouse.x = ev.clientX - $(zoning).offset().left;
        mouse.y = ev.clientY - $(zoning).offset().top; 
      }
    }
  };

  function handleMouseMove(e) {
    if(e.type === "touchmove"){
      e.preventDefault();
      if (isSelectingZone.current) {
        zoningContainer.style.touchAction = "none";
        zoningContainer.style.overflow = "hidden";
        setMousePosition(e);
        scrollZoning(e)
        if (element !== null) {
          element.style.width = Math.abs(mouse.x - mouse.startX) + 'px';
          element.style.height = Math.abs(mouse.y - mouse.startY) + 'px';
          element.style.left = (mouse.x - mouse.startX < 0) ?  parseInt(mouse.x) + 'px' :  parseInt(mouse.startX) + 'px';
          element.style.top = (mouse.y - mouse.startY < 0) ?  parseInt(mouse.y) + 'px' :  parseInt(mouse.startY)  + 'px';
        }
      }
    }else{
      setMousePosition(e);
      scrollZoning(e)
      if (element !== null) {
        element.style.width = Math.abs(mouse.x - mouse.startX) + 'px';
        element.style.height = Math.abs(mouse.y - mouse.startY) + 'px';
        element.style.left = (mouse.x - mouse.startX < 0) ?  parseInt(mouse.x) + 'px' :  parseInt(mouse.startX) + 'px';
        element.style.top = (mouse.y - mouse.startY < 0) ?  parseInt(mouse.y) + 'px' :  parseInt(mouse.startY)  + 'px';
      }
    }
  }

  function handleMouseDown(e) {
    if(e.type === "touchstart"){
      e.preventDefault()
      if (longPressTimer.current) {
        clearTimeout(longPressTimer.current);
      }
      mousedown.current = true;
      longPressTimer.current = setTimeout(() => {
        isSelectingZone.current = true;
        zoningContainer.style.touchAction = "none";
        zoningContainer.style.overflow = "hidden";
        setMousePosition(e);

      if (element === null) {
        mouse.startX = mouse.x;
        mouse.startY = mouse.y;
        zoning.textContent="";
        element = document.createElement('div');
        element.className = 'rectangle';
        element.style.position = "absolute";
        element.style.border = "2px solid #FF0000";
        element.style.left = parseInt(mouse.x) + 'px';
        element.style.top = parseInt(mouse.y) + 'px';
        zoning.appendChild(element);
        currentObjDragged.current = e.target
      }
    }, LONG_PRESS_DELAY)
    } else {
      mousedown.current = true;
      if (element === null) {
        mouse.startX = mouse.x;
        mouse.startY = mouse.y;
        zoning.textContent="";
        element = document.createElement('div');
        element.className = 'rectangle';
        element.style.position = "absolute";
        element.style.border = "2px solid #FF0000";
        element.style.left = parseInt(mouse.x) + 'px';
        element.style.top = parseInt(mouse.y) + 'px';
        zoning.appendChild(element);
        currentObjDragged.current = e.target
      }
    }
  }

  function handleMouseUp(e) {
    if(mousedown.current === true){
      if(e.type === "touchend"){
        e.preventDefault()
        if (longPressTimer.current) {
          clearTimeout(longPressTimer.current);
          longPressTimer.current = null;
          mousedown.current = false;

          if(isSelectingZone.current){
            isSelectingZone.current = false;
            zoningContainer.style.touchAction = "auto";
            zoningContainer.style.overflow = "auto";
            let zone = {};
            zone["name"] = pageNo +"_Zone" + (zoneList.length + 1) ;
            zone["Left"] = (mouse.x - mouse.startX < 0) ? parseInt(mouse.x) : parseInt(mouse.startX);
            zone["Top"] = (mouse.y - mouse.startY < 0) ? parseInt(mouse.y) : parseInt(mouse.startY);
            zone["Width"] = Math.abs(mouse.x - mouse.startX);
            zone["Height"] = Math.abs(mouse.y - mouse.startY);
            var array = [...zoneList];
            array.push(zone);
            setCard(zoneList.length);
            setZoneList(array);
            element = null;
          }
        }
      } else {
        mousedown.current = false;
        let zone = {};
        zone["name"] = pageNo +"_Zone" + (zoneList.length + 1) ;
        zone["Left"] = (mouse.x - mouse.startX < 0) ? parseInt(mouse.x) : parseInt(mouse.startX);
        zone["Top"] = (mouse.y - mouse.startY < 0) ? parseInt(mouse.y) : parseInt(mouse.startY);
        zone["Width"] = Math.abs(mouse.x - mouse.startX);
        zone["Height"] = Math.abs(mouse.y - mouse.startY);
        var array = [...zoneList];
        array.push(zone);
        setCard(zoneList.length);
        setZoneList(array);
        element = null;
      }
    }
  }

  if(zoning){
    zoning.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
  }

  useEffect(() => {
    document.getElementsByClassName("rectangle")[0]?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" })
   }, [card])

  return (
      <>
      <div>
      
      <Dialog 
      classes={{
        container: classes.dialogContainer,
        paper: matches ? classes.dialog : classes.dialogIpad
      }}
      open={open}    
      containerId={props.containerId}
      >
        <DialogTitle classes={{root:classes.dialogTitle}} >
            <div className={classes.dialogHead}>
              {t("Set Zoning")}
              <Badge  color="secondary"  style={{margin:"8px"}}>
              <img
              tabIndex={0}
                src={require("../../../../Icons/Help20.svg").default}
                alt="help" 
                onClick={()=> { const newWin = window.open(`/webhelp/resources/interface_designer?rhmapno=${helpDirection?.["zoning"]}`); handleWinObjects(newWin); }}
                target="_blank"
                style={{width:"20px",height:"20px",cursor:"pointer"}}
              />
            </Badge>
            </div>
            
        </DialogTitle>
        <Divider className={classes.divider}/>

        <DialogContent classes={{root:classes.dialogContent}} >
      
          { (img)?
            <>
              <Grid className={classes.container}>
              
              <Grid container className={classes.grid1} >
                <Grid className={classes.grid11} key={"check"} >
                <div className={classes.zoneHead}> {t("Defined Zones")} </div>
                
                { zoneList.map((zone, index) => {
                  return <ZoneCard containerId={props.containerId} zone={zone} index={index} state={card} zoneList={zoneList} setZoneList={setZoneList} pageNo={pageNo} multi={multi} handleState={handleState} handleChange2={handleChange2}/>             
                })} 
              
                </Grid>
              </Grid>
              <Grid id="zoningMainContainer" container className={classes.grid2} >
              <Grid id="zoningContainer" className={classes.grid21} >
                <div 
                id="zoning" 
                className={classes.div4} 
                style={zoneStyle} 
                onMouseDown={(e) => handleMouseDown(e)} 
                onTouchStart={(e) => handleMouseDown(e)}
                onMouseUp={(e) => handleMouseUp(e)} 
                onTouchEnd={(e) => handleMouseUp(e)}
                onMouseMove={(e) => handleMouseMove(e)}
                onTouchMove={(e) => handleMouseMove(e)}>
                </div>
              </Grid>
              { (multi)?
            
              <Grid className={classes.grid23}> 
                <div className={classes.div1}>
                  {fileName}
                </div>
                <div className={classes.div2}>
                  <div className={classes.div3}>
                  {t("Showing")} {pageNo} {t("of")} {pages}
                  </div>
                  <Pagination className={classes.root} renderItem={(item)=> <PaginationItem {...item} classes={{selected:classes.selected}} />} count={pages} defaultPage={1} page={pageNo} size="small" color="primary" onChange={handleChange1} >
                  </Pagination>
                    
                </div>
              </Grid>
              :
              <Grid className={classes.grid22}> {fileName} </Grid>
              
              }
              </Grid>
            </Grid>
          </>
        :
          (zoneList.length === 0) ?    
          <div className={classes.dragArea1}  onDrop={e => handleDrop(e)} onDragOver={e => onDragOver(e)} > 
              <div className={classes.image}>  </div>
              <div className={classes.header1} >
                  {t("Drag and drop files or")} &nbsp;
                  <input aria-label={"Zone File"} type="file" className="zoneFile" hidden onChange={(e) => handleFileInput(e)} accept='image/png,image/jpeg,.tiff'/>
                  <Button disableFocusRipple
                disableRipple
                tabIndex={0}
                  className={`formBuilder-MuiButton-outlined btn`} classes={{root:classes.uploadBtn,label:classes.uploadBtnlabel}} onClick={(e) => upload(e)} ><SvgImport color="#0072C6" />{t("Upload")}</Button>
              </div>
              <div className={classes.header2} >
                {t("JPG, PNG, TIFF or Up to 4MB")}
              </div>
          </div> 
          :
          <>
            <Grid className={classes.container}>
              
              <Grid container className={classes.grid1} >
                <Grid className={classes.grid11} key={"check"} >
                  <div className={classes.zoneHead}> {t("Defined Zones")} </div>
                  
                  { zoneList.map((zone, index) => {
                    return <ZoneCard containerId={props.containerId} zone={zone} index={index} state={card} zoneList={zoneList} setZoneList={setZoneList} pageNo={pageNo} multi={multi} handleState={handleState} handleChange2={handleChange2}/>             
                  })} 
                </Grid>
              </Grid>
              <Grid container className={classes.grid2} >
                  <div className={classes.dragArea2}  onDrop={e => handleDrop(e)} onDragOver={e => onDragOver(e)} > 
                      <div className={classes.image}>  </div>
                      <div className={classes.header1} >
                          {t("Drag and drop files or")} &nbsp;
                          <input aria-label={"Zone file1"} type="file" className="zoneFile" hidden onChange={(e) => handleFileInput(e)} accept='image/png,image/jpeg,.tiff'/>
                          <Button disableFocusRipple
                disableRipple
                tabIndex={0}
                  className={`formBuilder-MuiButton-outlined btn`} classes={{root:classes.uploadBtn,label:classes.uploadBtnlabel}} onClick={(e) => upload(e)} ><SvgImport color="#0072C6" />{t("Upload")}</Button>
                      </div>
                      <div className={classes.header2} >
                        {t("JPG, PNG, TIFF or Up to 4MB")}
                      </div>
                  </div>
              </Grid>
            </Grid>
          </>
        }

        </DialogContent>

        <DialogActions classes={{root: classes.dialogActions }} style={translationStyles?{paddingLeft:"10px"}:null} >    
            <Button disableFocusRipple
                disableRipple
                tabIndex={0}
                  className={`formBuilder-MuiButton-outlined`} classes={{root:classes.btn1,label:classes.btn1label}} onClick={handleCancel}>{t("Cancel")}</Button>
            <Button disableFocusRipple
                disableRipple
                tabIndex={0}
                  className={`formBuilder-MuiButton-outlined`} classes={{root:classes.btn2,label:classes.btn2label}} onClick={handleSave} color="primary">{t("Save & Exit")}</Button>    
        </DialogActions>
        {
              alertData.open === true &&
            <CustomizedAlert alertData={alertData} />
}

      </Dialog>
    </div>
    </>
  );
}
